export default __webpack_public_path__ + "static/media/default.955b6688.jpeg";